import React from 'react';
import cx from 'classnames';
import {string} from 'prop-types';

const NumberBadge = ( {color, textColor, children, className} ) =>
    <span
        className={cx(
            'shadow-sm flex-none w-10 h-10 rounded-full flex justify-center items-center',
            textColor && `text-${textColor}`,
            color && `bg-${color}`,
            className
        )}>
        {children}
    </span>;

NumberBadge.propTypes = {
    color: string,
    textColor: string
};

export default NumberBadge;
